/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { callStaffTgBotRequestRequestSchema } from "./callStaffTgBotRequestRequestSchema.ts";
import { callStaffTgBotResponseSchema } from "./callStaffTgBotResponseSchema.ts";
import { errorResponseSchema } from "./errorResponseSchema.ts";

export const orgUnitTableCallStaffCreatePathOrgUnitIdSchema = z.uuid();

export const orgUnitTableCallStaffCreatePathTableIdSchema = z.uuid();

export const orgUnitTableCallStaffCreateStatus200Schema = callStaffTgBotResponseSchema;

export const orgUnitTableCallStaffCreateStatus400Schema = errorResponseSchema;

export const orgUnitTableCallStaffCreateResponseSchema = z.union([orgUnitTableCallStaffCreateStatus200Schema, orgUnitTableCallStaffCreateStatus400Schema]);

export const orgUnitTableCallStaffCreateDataSchemaJson = callStaffTgBotRequestRequestSchema.optional();

export const orgUnitTableCallStaffCreateDataSchemaXml = callStaffTgBotRequestRequestSchema.optional();

export const orgUnitTableCallStaffCreateDataSchema = z.union([orgUnitTableCallStaffCreateDataSchemaJson, orgUnitTableCallStaffCreateDataSchemaXml]);
